import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

/**
 * RoleSelect
 * props:
 *  - rolesMaster: { [Macro]: string[] }  (da /ruoli)
 *  - value: string[]                     (ruoli selezionati)
 *  - onChange: (newValue: string[]) => void
 *  - label?: string
 */
export default function RoleSelect({ rolesMaster, value, onChange, label = 'Ruoli' }) {
  const options = useMemo(() => {
    if (!rolesMaster || typeof rolesMaster !== 'object') return [];
    const arr = [];
    for (const group of Object.keys(rolesMaster)) {
      (rolesMaster[group] || []).forEach(role => {
        if (role && typeof role === 'string') {
          arr.push({ label: role, group });
        }
      });
    }
    return arr;
  }, [rolesMaster]);

  return (
    <Autocomplete
      multiple
      options={options}
      value={(value || []).map(v => ({ label: v, group: options.find(o => o.label === v)?.group || '' }))}
      onChange={(_, newVal) => onChange(newVal.map(v => v.label))}
      groupBy={(opt) => opt.group}
      getOptionLabel={(opt) => opt.label}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Seleziona ruoli" />
      )}
      renderGroup={(params) => (
        <div key={params.key}>
          <div style={{ fontWeight: 700, padding: '6px 10px' }}>{params.group}</div>
          <div>{params.children}</div>
        </div>
      )}
      filterSelectedOptions
    />
  );
}
